import { gql } from '@apollo/client';

export const GET_CONTENT_AVERAGE_RATINGS = gql`
  query GetContentAverageRatings($contentIds: [Uuid!]!) {
    contentAverageRatings(where: { contentId: { _in: $contentIds } }) {
      contentId
      avgRating
      reviewCount
    }
  }
`;
